import ListComponent from './component'
import renderModal from '../modal/render'
import renderDialog from '../dialog/render'
import { commonRenderProps } from '../common/props'
import { openChargebeeCheckout } from '../common/useChargebee'

function getConnectedEmail(context) {
  const isPs17Regex = /(1.7.)/g
  if (isPs17Regex.test(context.shop_version)) {
    const buttonAddonsConnect: string = $(
      '#page-header-desc-configuration-addons_logout',
    )
      .text()
      .trim()
    return buttonAddonsConnect.split(' ').at(-1) || ''
  }

  const account = $('#page-header-desc-configuration-accounts_logout').attr(
    'data-original-title',
  )
  return account
    ? account.split(' ').at(-1)
    : $('#page-header-desc-configuration-addons_logout').text().trim()
}

export default (context: object, container: string) => {
  const currentUrl = new URL(window.location.href)

  const cdc_page = currentUrl.searchParams.get('mbo_cdc_path') || ''

  const search_query = new URLSearchParams(
    Object.fromEntries(
      Object.entries({
        categoryId: currentUrl.searchParams.get('filterCategoryRef'),
        developerId: currentUrl.searchParams.get('developer'),
        keyword: currentUrl.searchParams.get('keyword'),
        page: currentUrl.searchParams.get('page'),
        rate_above: currentUrl.searchParams.get('rate_above'),
        sortBy: currentUrl.searchParams.get('sortBy'),
        algolia_query_id: currentUrl.searchParams.get('algolia_query_id'),
        algolia_index: currentUrl.searchParams.get('algolia_index'),
        anchor: currentUrl.searchParams.get('anchor'),
        isVerifiedPlus: currentUrl.searchParams.get('isVerifiedPlus'),
      }).filter(([_, v]) => v != null),
    ) as Record<string, string>,
  ).toString()

  const cdc_path = cdc_page ? cdc_page + '?' + search_query : '/'

  const getModulesInTheSpotligthLink = () => {
    const isPs17Regex = /(1.7.)/g
    if (isPs17Regex.test((context as any).shop_version)) {
      return $('#subtab-AdminPsMboAddons').attr('href')
    }
    return $('#subtab-AdminPsMboSelection').attr('href')
  }

  const props = {
    ...commonRenderProps({ context }),

    url: import.meta.env.VITE_VUE_URL + cdc_path,

    handleOpenModal: (
      url: string,
      modalContext = context,
      onModuleAction: void,
      onModuleLoading: void,
    ) => {
      renderModal(modalContext, url, undefined, onModuleAction, onModuleLoading)
    },

    handleOpenDialog: (dialogName: string, dialogContext: object) => {
      renderDialog(context, dialogName, dialogContext)
    },

    connectedEmail: getConnectedEmail(context),

    modulesInTheSpotligthLink: getModulesInTheSpotligthLink(),

    handleAddonsLogoutCtaClick: () => {
      $('#page-header-desc-configuration-addons_logout').trigger('click')
    },

    handleUploadModuleCtaClick: () => {
      $('#page-header-desc-configuration-add_module').trigger('click')
    },

    handleHelpCtaClick: () => {
      $('#product_form_open_help').trigger('click')
    },

    handleOpenChargebeeCheckout: (opts) => {
      openChargebeeCheckout(opts)
    },
  }

  ListComponent(props).render(container)

  return ListComponent
}
